export default "__VITE_ASSET__8bef2d6e__"